import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useState } from "react";
import { Button } from "./Button";
import { Icon } from "./Icon";
import { triggerGlobalRefresh } from "../../lib/refresh";
import { t } from "../../i18n";
const MIN_BUSY_MS = 600;
export function RefreshButton({ size = "sm", showLabel = false, className }) {
    const [busy, setBusy] = useState(false);
    const handleClick = useCallback(() => {
        if (busy)
            return;
        setBusy(true);
        triggerGlobalRefresh();
        setTimeout(() => setBusy(false), MIN_BUSY_MS);
    }, [busy]);
    const label = t("common.refresh");
    return (_jsx(Button, { variant: "ghost", size: size, onClick: handleClick, disabled: busy, icon: _jsx(Icon, { name: "refresh-cw", size: "sm", className: busy ? "animate-spin" : undefined }), "aria-label": label, className: className, children: showLabel ? label : null }));
}
//# sourceMappingURL=RefreshButton.js.map